var render = function render(){var _vm=this,_c=_vm._self._c;return _c('df-messenger',{attrs:{"intent":"WELCOME","chat-icon":require('../../assets/image/speak.png'),"chat-title":"BronskyBot","agent-id":"12efffd8-3ba8-404f-8f6b-125ba5cc0a1f","language-code":"en"}})
}
var staticRenderFns = []

export { render, staticRenderFns }